import APIKit from "../Allapis/Apikit/apikit";

export const getNotifications = async (params) => {
  try {
    const url = `/notification`;
    const { name, userId, email, role } = params;
    const res = await APIKit.get(url, {
      params: { name, userId, email, role },
    });

    return res.data;
  } catch (e) {
    console.log(e);
  }
};
export const getNotificationList = async (id, filters = {}) => {
  try {
    const res = await APIKit.get("/admin/notifications/List", {
      params: {
        ...(id && { id }),
        ...filters,
      },
    });
    console.log(res, "jhjhjhjhj");
    return res.data;
  } catch (e) {
    console.error("Error in Fetching Notifications", e);
    throw e;
  }
};

export const sendNotications = async (values) => {
  try {
    const res = await APIKit.post(`/admin/notifications`, values);
    return res.data;
  } catch (e) {
    console.log(e, "Error in send Notifications");
  }
};
// export const getNotificationDetails = async (id) => {
//   try {
//     const res = await APIKit.get(`/notifications/List/${id}`);
//     console.log(res, "tetstetstettstetstetstetste");
//     return res.data;
//   } catch (e) {
//     console.log(e);
//   }
// };
